import React, { useState, useEffect } from "react";
import axios from "axios";
import { Row, Col } from "react-bootstrap";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import { DSR } from "../../ReusableComponents/CommonApis";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import { FaRegEdit } from "react-icons/fa";
import { HiMiniPlusSmall } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { SchoolData } from "../../Redux/Reducers/NCLadmin/AddEditSchool";
import { useSelector, useDispatch } from "react-redux";
import Loading from "../../Student/Reusablecomponents/Loading";
import { FaRegEye } from "react-icons/fa";
import { Society } from "../../ReusableComponents/NCLAdminDropdowns";
import { FaClockRotateLeft } from "react-icons/fa6";
import { ViewUserActivityLog } from "../../ReusableComponents/CommonApis";
import SchoolBulk from "./SchoolBulk";
import { MdOutlineFileUpload } from "react-icons/md";
import { RiFileExcel2Fill } from "react-icons/ri";
import {exportToExcel} from "../../Student/Reusablecomponents/RegularFunctions";
const Schools = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const TrackDetails = JSON.parse(localStorage.getItem("Schools"));
  const [SelectINID, SetSelectINID] = useState();
  const [Load, SetLoad] = useState(false);
  const [InstId, SetInstId] = useState();
  const [INAddres, SetINAddres] = useState();
  const [SRSData, SetSRSData] = useState(TrackDetails?.Region);
  const [SData, SetSData] = useState(TrackDetails?.State);
  const [DistData, SetDistData] = useState(TrackDetails?.District);
  const [SocietyId, SetSocietyId] = useState(TrackDetails?.Society);
  const [SchoolValues, setSchoolValues] = useState([]);
  const [visiblePasswords, setVisiblePasswords] = useState({});
  const [DisplaySchoolStatus, SetDisplaySchoolStatus] = useState("Active");
  const [LogData, SetLogData] = useState();
  const [OpenBulk, CloseBulk] = useState(false);

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const GetInstitutes = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(process.env.REACT_APP_API_BASE_URL + `/NCLAdmin/Institutes`, {
        headers: { XApiKey: process.env.REACT_APP_XApiKey },
      })
      .then((res) => {
        const Institutes = Array.from(
          res.data
            .reduce(
              (map, item) =>
                map.set(item.instituteName, {
                  display: item.instituteName,
                  value: item.instituteId,
                }),
              new Map()
            )
            .values()
        );
        SetSelectINID(TrackDetails?.INST || Institutes[0]);
        SetInstId(Institutes);
        SetINAddres(res.data);
        SetLoad((prev) => !prev);
      })
      .catch((err) => { console.log(err); });
  };

  useEffect(() => { GetInstitutes(); }, []);

  const HandleInstituteChange = (e) => {
    const Getinst = InstId?.filter((I) => I.value === Number(e))?.[0]
    SetSelectINID(Getinst);
    SetSRSData("");
    SetSData();
    SetDistData();
    SetSocietyId();
  };

  const HandleAddSchool = () => {
    const Tracking = {
      INST: SelectINID,
      Region: SRSData,
      State: SData,
      District: DistData,
      Society: SocietyId,
    };
    localStorage.setItem("Schools", JSON.stringify(Tracking));
    navigate("/NCLAdmin/Schools/AddSchool", { state: { UserID: Row?.userId, SchoolID: Row?.schoolID, SchoolName: Row?.schoolName } });
    dispatch(SchoolData({ AddEditSchoolDetails: "" }));
  };

  const handleEdit = (SingleSchool) => {
    const Tracking = {
      INST: SelectINID,
      Region: SRSData,
      State: SData,
      District: DistData,
      Society: SocietyId,
    };
    localStorage.setItem("Schools", JSON.stringify(Tracking));
    const [Region, State, District] = (() => {
      const parts = SingleSchool.hierarchyKey.split(",");
      return parts.length > 2 ? parts : [undefined, ...parts];
    })();
    const updatedData = { ...SingleSchool, Region, State, District };
    dispatch(SchoolData({ AddEditSchoolDetails: updatedData }));
    navigate("/NCLAdmin/Schools/AddSchool");
  };

  //To get schools
  const GetSchools = async () => {
    SetLoad((prev) => !prev);
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL +
        `/NCLAdmin/GetSchools?InstituteId=${SelectINID?.value}&Hvalue=${HIID()}&SocietyId=${SocietyId?.value || 0}&IsActive=${DisplaySchoolStatus === "Active" ? 1 : 0}`,
        {
          headers: { XApiKey: process.env.REACT_APP_XApiKey },
        }
      );
      setSchoolValues(response.data);
      SetLoad((prev) => !prev);
    } catch (error) {
      console.error("Error fetching School data:", error);
      return [];
    }
  };
  useEffect(() => {
    if (!OpenBulk && SelectINID && SData && DistData) { GetSchools(); }
  }, [SelectINID, SRSData, SData, DistData, SocietyId, DisplaySchoolStatus, OpenBulk]);

  const HIID = () => {
    if (SelectINID?.value === 1 || SelectINID?.value === 3 || SelectINID?.value === 6) {
      return [SRSData?.value, SData?.value, DistData?.value];
    }
    else if (SelectINID?.value === 2) {
      return [SData?.value, SRSData?.value, DistData?.value];
    }
    else {
      return [SData?.value, DistData?.value];
    }
  };
  const NavigateSchools = (Row) => {
    const Tracking = {
      INST: SelectINID,
      Region: SRSData,
      State: SData,
      District: DistData,
      Society: SocietyId,
    };
    localStorage.setItem("Schools", JSON.stringify(Tracking));
    navigate("/NCLAdmin/Schools/StudentDetails", { state: { UserID: Row?.userId, SchoolID: Row?.schoolID, SchoolName: Row?.schoolName,Section:Row?.sections } });
  }
  const Columns = [
    {
      name: "School Name", selector: "schoolName", sortable: true,
      cell: (row) => (<div className="LinkStyles" title="Click here to view Student registrations" onClick={() => NavigateSchools(row)}>{row.schoolName}</div>)
    },
    { name: "School U-DISC Code", selector: "udiseCode", sortable: false },
    { name: "Email Id", selector: "eMail", sortable: true },
    { name: "Contact Name", selector: "contactName", sortable: true },
    { name: "Contact Number", selector: "contactPhone", sortable: true },
    { name: "LoginId", selector: "loginId", sortable: true },
    {
      name: "Password",
      cell: (row) => (
        <div className="dflex h-100 gap-1" style={{ justifyContent: "center" }}>
          {visiblePasswords[row.password] ? (<span>{row.password}</span>) : (<span style={{ fontsize: "10px" }}>******</span>)}
          <FaRegEye className="CPointer" title={visiblePasswords[row.password] ? "Hide Password" : "Show Password"}
            onClick={() => setVisiblePasswords((prev) => ({ ...prev, [row.password]: !prev[row.password], }))} />
        </div>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="dflex JCCenter" >
          <FaRegEdit title="Edit School Details" className="CPointer" style={{ color: "#624DE3" }} size={18} onClick={() => handleEdit(row)} />
        </div>
      ),
    },
  ];
   const DownloadFIle = () => {
          const XL = SchoolValues?.map((item, index) => {
              return {
                  "S.No": index + 1,
                  "School Name": item?.schoolName,
                  "School UDISE": item?.udiseCode,
                  "Email ID": item?.eMail,
                  "Contact Name": item?.contactName,
                  "Contact Number": item?.contactPhone,
                  "Login ID": item?.loginId,
                  "Password": item?.password,
              }
  
          })
          exportToExcel(XL, `School Deatils - ${SelectINID?.display}`, false,  "School Deatils",`School Deatils - ${SelectINID?.display}`, true);
      }
  return (
    <>
      <div className="TeacherBgImage">
        <div className="MainHeading" style={{ marginTop: "10px" }}>
          Schools
        </div>
        <div className="container-fluid mt-2 InputFIlters">
          <label>Input</label>
          <br />
          <Row>
            <Col>
              {InstId && (
                <DropdownValues className="NCLDropdown w-100" options={InstId} selectoption={SelectINID?.value}
                  onChange={(e) => { HandleInstituteChange(e.target.value); }}
                  labelname={<div className="DropdownHeader">Institute :</div>} />)}
            </Col>

            {(SelectINID?.value === 8 || SelectINID?.value === 9 || SelectINID?.value === 5) && (
              <Col>
                <Society
                  className="NCLDropdown w-100"
                  PId={SelectINID?.value}
                  id="0"
                  SOption={SocietyId}
                  StoreValue={SetSocietyId}
                  onChange={(e) => {
                    SetSocietyId(e);
                  }}
                  labelname={<div className="DropdownHeader">Society :</div>}
                />
              </Col>
            )}
            {SelectINID?.value === 2 ? (
              <>
                {/* State */}
                <Col>
                  <DSR className="NCLDropdown w-100" GetFDateail={true} PId={SelectINID?.value} SID="0"
                    StoreValue={SetSData} SOption={SData?.value} RID="0" labelname={<div className="DropdownHeader">State :</div>}
                    // INALL={true}
                    onChange={(e) => { SetSData(e); SetSRSData(""); SetDistData(""); }} />
                </Col>
                {/* Region */}
                <Col>
                  <DSR className="NCLDropdown w-100" PId={SelectINID?.value} RID="0" GetFDateail={true}
                    SID={SData?.value || 0} StoreValue={SetSRSData} SOption={SRSData?.value}
                    // INALL={true}
                    onChange={(e) => { SetSRSData(e); SetDistData(""); }}
                    labelname={<div className="DropdownHeader">Region :</div>} />
                </Col>
                {/* District*/}
                <Col>
                  <DSR GetFDateail={true} className="NCLDropdown w-100" PId={SelectINID?.value} SID={SData?.value || 0}
                    StoreValue={SetDistData} SOption={DistData?.value} RID={SRSData?.value || 0} INALL={true}
                    onChange={(e) => { SetDistData(e); }} labelname={<div className="DropdownHeader">District :</div>} />
                </Col>
              </>
            ) : (
              <>
                {(SelectINID?.value === 1 || SelectINID?.value === 3 || SelectINID?.value === 6) && (
                  <Col>
                    <DSR className="NCLDropdown w-100" GetFDateail={true} PId={SelectINID?.value} RID="0"
                      SID="0" StoreValue={SetSRSData} SOption={SRSData?.value} onChange={(e) => { SetSRSData(e); }}
                      labelname={<div className="DropdownHeader">Region :</div>} />
                  </Col>
                )}

                <Col>
                  <DSR className="NCLDropdown w-100" GetFDateail={true} PId={SelectINID?.value} INALL={true}
                    SID="0" StoreValue={SetSData} SOption={SData?.value} RID={SRSData?.value || 0}
                    onChange={(e) => { SetSData(e); }} labelname={<div className="DropdownHeader">State :</div>} />
                </Col>

                <Col>
                  <DSR GetFDateail={true} className="NCLDropdown w-100" PId={SelectINID?.value}
                    SID={SData?.value || 0} StoreValue={SetDistData} SOption={DistData?.value}
                    RID={SRSData?.value || 0} INALL={true} onChange={(e) => { SetDistData(e); }}
                    labelname={<div className="DropdownHeader">District :</div>} />
                </Col>
              </>
            )}
          </Row>
        </div>
        <div className="dflex JSBetween alignitems mt-2" >
          <div>
            <b className="dflex alignitems JCCenter gap-1 CPointer" style={{ whiteSpace: "nowrap", color: "#4450D3", }}
              onClick={() => SetLogData(true)} > <FaClockRotateLeft fontSize={20} /> View Activity Log</b></div>
          <div className="dflex alignitems gap-3">
            <div className="dflex gap-3">
              <span>
                <input type="radio" name="ActiveStatus" value="Active"
                  defaultChecked={DisplaySchoolStatus === "Active"}
                  onChange={(e) => {
                    SetDisplaySchoolStatus(e.target.value);
                    setSchoolValues([]);
                  }}
                /> Active </span>
              <span style={{ color: "#878997" }}>
                {" "}
                <input type="radio" name="ActiveStatus" value="Inactive"
                  defaultChecked={DisplaySchoolStatus === "Inactive"}
                  onChange={(e) => {
                    SetDisplaySchoolStatus(e.target.value);
                    setSchoolValues([]);
                  }}
                />{" "}
                Inactive{" "}
              </span>
            </div>
            {DistData?.value !== -1 &&
              <button className="Buttons AddButton dflex alignitems JCCenter gap-1" onClick={HandleAddSchool}> <HiMiniPlusSmall /> Add School </button>
            }
            {DistData?.value === -1 && ![1, 3].includes(SelectINID?.value) && SData?.value !== -1 && 
              <button className="Buttons AddButton dflex alignitems JCCenter gap-1" onClick={() => { CloseBulk(true) }}>
                <MdOutlineFileUpload /> Bulk Upload</button>}
               {SchoolValues?.length > 0 && <div className="ExportExcel dflex alignitems gap-2" onClick={()=>{DownloadFIle()}} title="Export to Excel"> <RiFileExcel2Fill size={40}/>  </div>}
          </div>
        </div>

        {LogData && (<ViewUserActivityLog UserId={items?.userId} UTId={2} Close={() => SetLogData(false)} />)}

        <DataTable data={SchoolValues} columns={Columns} className="NCLDataTable Card mt-2"
          Dropdownvalues={["10", "25", "50", "100"]} ShowPagination={true} ShowPagecount={true} />
      </div>
      {OpenBulk && <div className="Model-Open">
        <div className="Card w-50 pt-2">
          <SchoolBulk Close={CloseBulk} SINID={SelectINID} SRegion={SRSData} SStatte={SData} Sdistrict={DistData}
            SSociety={SocietyId} />
        </div>
      </div>}
      {Load && <Loading />}
    </>
  );
};
export default Schools;
